import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66dbf16d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "outer-input-container" }
const _hoisted_2 = { class: "input-container" }
const _hoisted_3 = { class: "display-list items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa = _resolveComponent("fa")!

  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[1] || (_cache[1] = e => _ctx.bgClick(e)),
    class: "bg",
    ref: _ctx.id
  }, [
    _createElementVNode("div", null, [
      _renderSlot(_ctx.$slots, "header", { class: "items-center" }, () => [
        _createTextVNode("Search")
      ], true),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("input", {
            onInput: _cache[0] || (_cache[0] = e => _ctx.handleInput(e)),
            class: "input"
          }, null, 32),
          _createVNode(_component_fa, {
            class: "input-icon",
            icon: "magnifying-glass"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "items", {}, () => [
          _createTextVNode("No results")
        ], true)
      ])
    ])
  ], 512))
}